<template>
  <div class="wizard">
    <div class="sm:pb-24">
      <step-what
        v-if="currStep === 1"
        :items="itemWhats"
        @on-change="onChange"
        @on-continue="onContinue"
        @loading="setLoading"
        :curr-selection="currSelection"
        :curr-step="currStep"
      />
      <step-when
        v-if="currStep === 2"
        :items="itemWhens"
        @on-change="onChange"
        @on-back="onBack"
        @on-continue="onContinue"
        @on-skip="onSkip"
        @loading="setLoading"
        :curr-selection="currSelection"
        :curr-step="currStep"
      />
      <step-where
        v-if="currStep === 3"
        :items="itemWheres"
        @on-change="onChange"
        @on-back="onBack"
        @on-continue="onContinue"
        @on-skip="onSkip"
        @loading="setLoading"
        :loading="loading"
        :curr-selection="currSelection"
        :curr-step="currStep"
      />

      <wizard-progress v-if="loading" />
    </div>
  </div>
</template>

<script>
import WizardProgress from "../../components/Wizard/Progress";
import { getQueryStringValue } from "../../helpers";
// steps
import StepWhat from "../../views/wizard/StepWhat";
import StepWhen from "../../views/wizard/StepWhen";
import StepWhere from "../../views/wizard/StepWhere";

export default {
  name: "WizardPanel",
  props: {
    itemWhats: {
      type: Array,
      default: () => [],
    },
    itemWhens: {
      type: Array,
      default: () => [],
    },
    itemWheres: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    WizardProgress,
    StepWhat,
    StepWhen,
    StepWhere,
  },
  mounted() {
    if (
      getQueryStringValue("w") &&
      !isNaN(getQueryStringValue("w")) &&
      Boolean(Number(getQueryStringValue("w")))
    ) {
      this.nextStep();
    }

    this.init();
    setTimeout(() => {
      this.triggerListeners();
    }, 500);
  },
  watch: {
    currStep() {
      const templateWrapper = document.querySelector(
        ".zb-modal-scrollable-content"
      );
      if (templateWrapper) {
        templateWrapper.scrollTo({ top: 0 });
      }
    },
  },
  data() {
    return {
      currStep: 1,
      currSelection: {},
      loading: false,
    };
  },
  methods: {
    init() {
      let currSelection = Object.assign({}, this.currSelection);

      if (getQueryStringValue("what")) {
        currSelection["what"] = this.itemWhats.filter((s) =>
          Boolean(
            getQueryStringValue("what")
              .split("+")
              .find((sp) => sp === s.value)
          )
        );
      }

      if (getQueryStringValue("when")) {
        currSelection["when"] = this.itemWhens.find(
          (s) => s === getQueryStringValue("when")
        );
      }

      if (getQueryStringValue("where")) {
        currSelection["where"] = this.itemWheres.filter((s) =>
          Boolean(
            getQueryStringValue("where")
              .split("+")
              .find((sp) => sp === s.value)
          )
        );
      }

      this.currSelection = currSelection;
    },
    nextStep(step = 1) {
      this.currStep = step;
    },
    onContinue() {
      if (this.currStep > 3) {
        return;
      }
      this.currStep++;
    },
    onBack() {
      if (this.currStep < 2) {
        return;
      }

      this.currStep--;
    },
    onSkip() {
      if (this.currStep > 3) {
        return;
      }
      this.currStep++;
    },
    onChange(selected) {
      let currStep = ["what", "when", "where"][this.currStep - 1];
      let currSelection = Object.assign({}, this.currSelection);
      currSelection[currStep] = selected;
      this.currSelection = currSelection;
    },
    triggerListeners() {
      const triggerstep1 = document.querySelectorAll(".wizard-cta-1");
      const triggerstep2 = document.querySelectorAll(".wizard-cta-2");
      const triggerstep3 = document.querySelectorAll(".wizard-cta-3");

      for (let trigger of triggerstep1) {
        trigger.addEventListener("click", () => this.nextStep(1));
      }

      for (let trigger of triggerstep2) {
        trigger.addEventListener("click", () => this.nextStep(2));
      }

      for (let trigger of triggerstep3) {
        trigger.addEventListener("click", () => this.nextStep(3));
      }
    },
    setLoading(loading) {
      this.loading = loading;
    },
  },
};
</script>
